import { IUpdateInstalledApplication } from 'common/actions/integrations/Applications/interfaces'

interface IState {
  applications: {
    updateApplication: IUpdateInstalledApplication
  }
}

const getState = (state: IState) => state.applications.updateApplication

export const getApplicationId = (state: IState) => getState(state).applicationId

export const getFetching = (state: IState) => getState(state).changelog.fetching

export const getUpdateFetching = (state: IState) => getState(state).updateFetching

export const getChangelogs = (state: IState) => getState(state).changelog.changelogs

export const getStage = (state: IState) => getState(state).stage
